import type { CartItem } from '../types';
import { clampProductQuantity } from './bookingFlowProducts';

/** Map DB cart_sessions.items JSON into CartItem[] for recovery (dates as Date). */
export function mapRecoveredCartItems(rawItems: unknown): CartItem[] {
  if (!Array.isArray(rawItems) || rawItems.length === 0) return [];

  return rawItems.map((item: any) => {
    const product = item?.product ?? {};
    const quantity = clampProductQuantity(product, Number(item?.quantity) || 1);
    return {
      ...item,
      quantity,
      startDate: item?.startDate ? new Date(item.startDate) : item?.startDate,
      endDate: item?.endDate ? new Date(item.endDate) : item?.endDate,
    };
  }) as CartItem[];
}

export type RecoverCartResponse = {
  success?: boolean;
  sessionId?: string;
  items?: unknown;
  error?: string;
};

/**
 * session_id is a UUID v4 (122 bits entropy) stored only in the customer's browser /
 * recovery email link. Sufficient as recovery secret for this product surface;
 * no separate recovery_token column needed for P0.
 */
export function isValidCartRecoverySessionId(sessionId: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    sessionId.trim(),
  );
}
